
export function isNullOrUndefinedObject(objectToCheck: object): boolean {
  return (objectToCheck === undefined || objectToCheck == null) ? true : false;
}

export function isNotUndefinedOrFalse(valueToCheck: boolean): boolean {
  return (valueToCheck === undefined || valueToCheck === false) ? false : true;
}

export function isNullOrEmpty(stringToCheck: string): boolean {
  return (stringToCheck === undefined || stringToCheck == null || stringToCheck === '' || (typeof stringToCheck === 'string'? (stringToCheck.trim() === '' ? true : false) : false )) ? true : false;
}


export function isNullOrUndefinedBoolean(booleanToCheck: boolean): boolean {
  return (booleanToCheck === undefined || booleanToCheck == null) ? true : false;
}
export function isNullOrUndefinedNumber(numberToCheck: number): boolean {
  return (numberToCheck === undefined || numberToCheck == null) ? true : false;
}
export function isNullOrUndefined(objectToCheck: object): boolean {
  return (objectToCheck === undefined || objectToCheck == null) ? true : false;
}

export function isValidLength(minLength: number, maxLength: number, stringToCheck: string): boolean{
  return (stringToCheck.length < minLength || stringToCheck.length > 150) ? false : true ;

}
